// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__k_z0R","content":"LayoutSettings_content__2R0QV"};